import { render, staticRenderFns } from "./chartNormal.vue?vue&type=template&id=6bfacf7d&"
import script from "./chartNormal.vue?vue&type=script&lang=js&"
export * from "./chartNormal.vue?vue&type=script&lang=js&"
import style0 from "./chartNormal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports